import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Button} from 'shared/components';

const ActionButtons = observer(({uiState}) => {
  return (
    <Button.Group>
      <Button onClick={() => uiState.approve()}>
        <FormattedMessage id='expenses.expense_requests.detail.Approve' />
      </Button>
      <Button trait='default' onClick={() => uiState.reject()}>
        <FormattedMessage id='expenses.expense_requests.detail.Reject' />
      </Button>
    </Button.Group>
  );
});

export default ActionButtons;
